import { render, staticRenderFns } from "./Speciality.vue?vue&type=template&id=65eb3e9f&scoped=true&"
import script from "./Speciality.vue?vue&type=script&lang=js&"
export * from "./Speciality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb3e9f",
  null
  
)

export default component.exports